export default __webpack_public_path__ + "static/media/gallery_00.0e04d6fc.jpg";